import { render, staticRenderFns } from "./BotFooter.vue?vue&type=template&id=8d15df20&scoped=true"
import script from "./BotFooter.vue?vue&type=script&lang=js"
export * from "./BotFooter.vue?vue&type=script&lang=js"
import style0 from "./BotFooter.vue?vue&type=style&index=0&id=8d15df20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d15df20",
  null
  
)

export default component.exports